export default __webpack_public_path__ + "static/media/logo.fae5dce7.svg";